import { Component, OnInit, inject } from "@angular/core";
import { injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/report/i18n/scope";
import { Pages } from "../../../common/constants/pages/Pages";
import { TabService } from "../../../services/tabs/TabService";
import { ReportDataService } from "../services/ReportDataService";
import { ReportItem } from "../shared/ReportItem";
import { CerrixPromptService } from "@app/shared/services/cerrix-prompt.service";
import {
    GenericListField,
    GenericListFieldType,
} from "@app/shared/models/GenericList/GenericListField";
import { firstValueFrom } from "rxjs";
import { NgxMasonryModule } from "ngx-masonry";
import { TranslatePipe } from "@app/shared/i18n/translation-scope";

@Component({
    selector: "app-report-overview",
    templateUrl: "./report-overview.component.html",
    styleUrls: ["./report-overview.component.scss"],
    viewProviders: [provideTranslationScope(scope)],
    imports: [NgxMasonryModule, TranslatePipe],
})
export class ReportOverviewComponent implements OnInit {
    tabService = inject(TabService);
    pages = inject(Pages);
    private _reportDS = inject(ReportDataService);
    private _promptService = inject(CerrixPromptService);
    private _translation = injectTranslation(scope);

    data: ReportItem[];
    allModules: Record<string, string>;

    protected finishedLoading = false;

    async ngOnInit() {
        // download() builds its dialog labels with t(), which needs the scope loaded first.
        await this._translation.ready();

        this.allModules = await firstValueFrom(this._reportDS.getModules());
        this.data = await firstValueFrom(this._reportDS.getList());

        this.finishedLoading = true;
    }

    getCategories() {
        const modules = this.allModules;
        const items = this.data.map(function (a) {
            if (modules) {
                return modules[a.Module];
            }
        });
        return new Set(items);
    }

    getCategoryReports(c: string): ReportItem[] {
        const modules = this.allModules;
        const items = this.data.filter(function (a) {
            if (modules) {
                return modules[a.Module] === c;
            }
        });
        return items;
    }

    open(report: ReportItem) {
        this.tabService.generateTab(this.pages.PowerBIReport, report.ID, report.Name);
    }

    download(report: ReportItem) {
        this._promptService
            .prompt({
                maxHeight: 400,
                data: {
                    confirmOnEnter: false,
                    closeOnEsc: false,
                    title: this._translation.t("exportFilterTitle"),
                    fields: [
                        {
                            prettyName: this._translation.t("filterLabel"),
                            fieldName: "filter",
                            fieldType: GenericListFieldType.TextArea,
                            customValidation: (row) => {
                                const isInvalid = row.filter && row.filter.length > 2000;
                                return {
                                    makeRequired: isInvalid,
                                    validation: isInvalid
                                        ? this._translation.t("filterMaxLengthError")
                                        : "",
                                };
                            },
                        },
                    ],
                    confirmButton: {
                        text: this._translation.t("okButton"),
                    },
                    cancelButton: {
                        show: true,
                    },
                },
            })
            .getResult()
            .subscribe((result) => {
                if (result) {
                    let filter = result.filter.replace(/\n/g, " ");
                    this._reportDS.export(report.ID, filter);
                }
            });
    }
}
